import React, { useState, useEffect } from 'react';
import { Box, Button, Grid } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import consts from "../../constant";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

const drawerWidth = 260;

const StakingView = () => {
    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));
    const path = usercalls();
    const navigate = useNavigate();
    const location = useLocation();

    const [limit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [getUserList, setGetUserList] = useState([]);

    // Getting stacking details from navigation state
    const stacking = location?.state;

    // Function to fetch staking data
    const getAllUserStakingDetails = async () => {
        try {
            const url = `${consts.BackendUrl}/admin/getStakedDetails`;

            let payload = {
                "duration": stacking?.duration,
                "user_id": stacking?.user_id // Ensure correct ID is passed
            };

            const response = await path.postCall({ url, payload });
            const result = await response.json();

            console.log(result, 'Fetched Staking Data');

            if (result?.success) {
                setGetUserList(result);
                setTotalPage(Math.ceil(result?.result?.length / limit));
            }
        } catch (error) {
            console.log("🚀 ~ getAllUserStakingDetails ~ error", error);
        }
    };

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getAllUserStakingDetails();
        } else {
            navigate(`/${consts.route + '/login'}`);
        }
    }, [limit, page]);

    // Function to format date
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit"
        });
    };

    return (
        <div className="UserList">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
                >
                    {/* Back Button */}
                    <div style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        height: "50px",
                        width: "100%",
                        padding: "10px"
                    }}>
                        <Button
                            variant="contained"
                            style={{
                                color: "black",
                                backgroundColor: "lightblue",
                                fontWeight: "bold",
                                width: "150px",
                                height: "40px"
                            }}
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </Button>
                    </div>

                    {/* Staking Table */}
                    <Grid item xs={12}>
                        <div className="custom_table">
                            <TableContainer>
                                <Table aria-label="staking table">
                                    <TableHead>
                                        <TableRow>
                                            {["Type", "Stake Amount", "Admin Profit / Loss Amount", "Stake balance", "Duration", "Update Date", "Over All Total Profit", "Over All Total Loss"]
                                                .map((header) => (
                                                    <TableCell key={header} align="center" sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getUserList?.result?.length > 0 ? (
                                            getUserList?.result.map((item, index) => (
                                                <TableRow key={index}>
                                                    {/* Profit/Loss Type */}
                                                    <TableCell align="center">
                                                        {item?.type === "loss" ? (
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <ArrowDownward style={{ color: "red", marginRight: 5 }} />
                                                                <h3>Loss</h3>
                                                            </div>
                                                        ) : (
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <ArrowUpward style={{ color: "green", marginRight: 5 }} />
                                                                <h3>Profit</h3>
                                                            </div>
                                                        )}
                                                    </TableCell>

                                                    {/* Profit/Loss Amount */}
                                                    <TableCell align="center">{item?.stack_amount}</TableCell>

                                                    <TableCell align="center">{item?.amount}</TableCell>
                                                    <TableCell align="center">{item?.stak_balance}</TableCell>


                                                    {/* Duration */}
                                                    <TableCell align="center">{item?.stak_duration} months</TableCell>


                                                    {/* Created At Date */}
                                                    <TableCell align="center">{formatDate(item?.createdAt)}</TableCell>


                                                    {/* <TableCell align="center">{getUserList?.totalStaked} TJRM </TableCell> */}
                                                    <TableCell align="center">{getUserList?.totalProfitDistributed} TJRM </TableCell>
                                                    <TableCell align="center">{getUserList?.totalLossDeducted} TJRM </TableCell>

                                                    {/* User Staking Details */}
                                                    {/* <TableCell align="center">
                                                        {item?.updateUserDetails ? (
                                                            <div>
                                                                <p><strong>Staking Balance:</strong> {item?.updateUserDetails?.stak_balance}</p>
                                                                <p><strong>User Staked Amount:</strong> {item?.updateUserDetails?.stack_amount}</p>
                                                                <p><strong>Duration:</strong> {item?.updateUserDetails?.stak_duration} Months</p>
                                                            </div>
                                                        ) : "No Data Found"}
                                                    </TableCell> */}
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={12} align="center">No Staking Data Found</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Pagination */}
                            <Pagination
                                className='pagination'
                                count={totalPage}
                                page={page}
                                onChange={(event, value) => setPage(value)}
                                variant="outlined"
                                shape="rounded"
                                sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                            />
                        </div>
                    </Grid>
                </Box>
            </Box>
        </div>
    );
};

export default StakingView;
